var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.5C0 10.1863 2.68629 7.5 6 7.5H42C45.3137 7.5 48 10.1863 48 13.5V34.5C48 37.8137 45.3137 40.5 42 40.5H6C2.68629 40.5 0 37.8137 0 34.5V13.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 8.5H6C3.23858 8.5 1 10.7386 1 13.5V34.5C1 37.2614 3.23858 39.5 6 39.5H42C44.7614 39.5 47 37.2614 47 34.5V13.5C47 10.7386 44.7614 8.5 42 8.5ZM6 7.5C2.68629 7.5 0 10.1863 0 13.5V34.5C0 37.8137 2.68629 40.5 6 40.5H42C45.3137 40.5 48 37.8137 48 34.5V13.5C48 10.1863 45.3137 7.5 42 7.5H6Z",
    fill: "#E4E4E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8666 28.8557H19.2744L20.8958 19.1755H23.4879L21.8666 28.8557Z",
    fill: "#1A1F71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2633 19.4121C30.752 19.2162 29.941 19 28.9383 19C26.3783 19 24.5757 20.3181 24.5646 22.2026C24.5434 23.5929 25.8553 24.3652 26.8365 24.8287C27.8394 25.3025 28.1803 25.6117 28.1803 26.0339C28.1701 26.6824 27.3699 26.9814 26.6236 26.9814C25.5886 26.9814 25.0341 26.8272 24.1914 26.4664L23.85 26.3118L23.4873 28.4848C24.0953 28.7522 25.2154 28.9896 26.3783 29C29.0983 29 30.8691 27.7023 30.89 25.6941C30.9004 24.5921 30.2076 23.7477 28.7141 23.0577C27.8075 22.6148 27.2522 22.3162 27.2522 21.863C27.2629 21.451 27.7219 21.029 28.7453 21.029C29.588 21.0083 30.2072 21.2039 30.6763 21.3997L30.9107 21.5024L31.2633 19.4121Z",
    fill: "#1A1F71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7088 25.4264C34.9223 24.8703 35.7438 22.7179 35.7438 22.7179C35.733 22.7386 35.9568 22.1515 36.0848 21.7911L36.266 22.6252C36.266 22.6252 36.7569 24.9424 36.8635 25.4264C36.4583 25.4264 35.2208 25.4264 34.7088 25.4264ZM37.9086 19.1755H35.9035C35.2852 19.1755 34.8154 19.3504 34.5487 19.9787L30.6982 28.8556H33.4182C33.4182 28.8556 33.866 27.6608 33.9622 27.4035C34.2606 27.4035 36.9066 27.4035 37.2904 27.4035C37.3648 27.7434 37.5997 28.8556 37.5997 28.8556H39.9999L37.9086 19.1755Z",
    fill: "#1A1F71"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.109 19.1755L14.5703 25.7765L14.2929 24.4377C13.8236 22.893 12.3516 21.2146 10.709 20.3801L13.0343 28.8455H15.7755L19.85 19.1755H17.109Z",
    fill: "#1A1F71"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2133 19.1755H8.04267L8 19.3711C11.2534 20.1744 13.408 22.1107 14.2932 24.4381L13.3866 19.9892C13.2373 19.3709 12.7786 19.1959 12.2133 19.1755Z",
    fill: "#1A1F71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.283e45ed5762b47ffbc8c7ddf110145f.svg";
export { ForwardRef as ReactComponent };